__webpack_require__.p = "https://brownstein.github.io/protosprite/";